//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    cols: {
      type: Number,
      default: 1,
    },
    // 旧来のcol/row指定によるgrid-template-columnsレイアウト（option/request.vue用）
    grid: {
      type: Boolean,
      default: false,
    },
    // バナー2枚以下の新デザイン（432x243上限・中央揃え。ody/odg用）
    compact: {
      type: Boolean,
      default: false,
    },
    // GA4計測用。'yasai' / 'gohan' など。未指定の場合は計測しない
    bannerType: {
      type: String,
      default: null,
    },
  },
  computed: {
    // option/request.vue（grid指定時）向け。item.col/item.rowからgrid-column/grid-rowを算出する
    gridStyle() {
      const style = []

      let colStart = 1
      let colEnd = 1
      let rowStart = 1
      let rowEnd = 1

      let nextColEnd = 0

      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]

        colEnd = colStart + item.col
        rowEnd = rowStart + item.row

        style.push({
          gridColumn: `${colStart} / ${colEnd}`,
          gridRow: `${rowStart} / ${rowEnd}`,
        })

        if (item.row === 2) {
          nextColEnd += 1
        }

        if (colEnd === 3) {
          colStart = nextColEnd + 1
          rowStart += 1
        } else {
          rowEnd = rowStart + 1
          colStart += 1
        }
      }

      return style
    },
    isRowSingle() {
      return (
        this.grid &&
        this.list.length <= 2 &&
        !this.list.some((item) => item.col >= 2)
      )
    },
  },
  mounted() {
    // mounted直後だとgtag.js側の初期化と競合することがあるため、
    // 1ティック遅らせてから送信する
    setTimeout(() => {
      if (!this.bannerType || !this.$gtag) {
        return
      }

      this.list.forEach((item, index) => {
        this.trackImpression(item, index)
      })
    }, 0)
  },
  methods: {
    // request_banner.php の imgPath（例: images/banner/202610y_01.png）から
    // 月替わりでも一意になるバナーidを導出する（例: 202610y_01）
    bannerId(item) {
      const filename = item.imgPath.split('/').pop()

      return filename.replace(/\.[^.]+$/, '')
    },
    bannerPosition(index) {
      return index === 0 ? 'left' : 'right'
    },
    trackImpression(item, index) {
      if (!this.$gtag) {
        return
      }

      this.$gtag.event('request_banner_impression', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: this.bannerPosition(index),
        request_banner_version: 'static',
        request_banner_impression_value: 1,
      })
    },
    trackClick(item, index) {
      // openInNewTabが真=外部リンクとして実遷移させるため、ページ内スクロールは発生させない
      if (!item.openInNewTab) {
        // @item-clickのリスナーが無い呼び出し元（例: option/request.vue）向けに、
        // 以前の<Link :to>と同等のルーター遷移にフォールバックする
        if (this.$listeners['item-click']) {
          this.$emit('item-click', item)
        } else {
          // 同じバナーへの連打でNavigationDuplicatedが未処理のPromise拒否になるのを防ぐ
          this.$router.push(item.link).catch(() => {})
        }
      }

      if (!this.bannerType || !this.$gtag) {
        return
      }

      this.$gtag.event('request_banner_click', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: this.bannerPosition(index),
        request_banner_version: 'static',
        request_banner_click_value: 1,
      })
    },
  },
}
